import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const BurgerMenu = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { language, setLanguage } = useLanguage();

    // Toggle the menu
    const handleMenuToggle = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <nav className="fixed right-4 top-4 z-50 sm:right-6 sm:top-6">
            <button
                onClick={handleMenuToggle}
                type="button"
                className="inline-flex h-12 w-12 items-center justify-center rounded-lg border border-gray-300 bg-white text-gray-700 shadow-sm hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
                aria-controls="navbar-default"
                aria-expanded={isMenuOpen}
            >
                <span className="sr-only">Open main menu</span>
                <svg
                    className="h-6 w-6"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 17 14"
                >
                    <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M1 1h15M1 7h15M1 13h15"
                    />
                </svg>
            </button>

            <div
                className={`${isMenuOpen ? 'block' : 'hidden'} absolute right-0 top-14 w-56 rounded-lg border border-gray-200 bg-white shadow-lg`}
                id="navbar-default"
            >
                <ul className="flex flex-col p-2 text-sm font-medium">
                    <li>
                        <NavLink
                            to="/"
                            onClick={() => setIsMenuOpen(false)}
                            className={({ isActive }) =>
                                `block rounded-md px-3 py-2 ${isActive ? 'bg-blue-50 text-blue-700' : 'text-gray-900 hover:bg-gray-100'}`
                            }
                        >
                            Dashboard
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/history"
                            onClick={() => setIsMenuOpen(false)}
                            className={({ isActive }) =>
                                `block rounded-md px-3 py-2 ${isActive ? 'bg-blue-50 text-blue-700' : 'text-gray-900 hover:bg-gray-100'}`
                            }
                        >
                            Homework History
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/upcoming"
                            onClick={() => setIsMenuOpen(false)}
                            className={({ isActive }) =>
                                `block rounded-md px-3 py-2 ${isActive ? 'bg-blue-50 text-blue-700' : 'text-gray-900 hover:bg-gray-100'}`
                            }
                        >
                            Upcoming Events
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/deadline"
                            onClick={() => setIsMenuOpen(false)}
                            className={({ isActive }) =>
                                `block rounded-md px-3 py-2 ${isActive ? 'bg-blue-50 text-blue-700' : 'text-gray-900 hover:bg-gray-100'}`
                            }
                        >
                            Check Deadlines
                        </NavLink>
                    </li>
                    <li className="mt-2 border-t border-gray-200 px-2 pt-3">
                        <span className="block text-xs font-semibold uppercase tracking-wide text-gray-500">
                            Language / 語言
                        </span>
                        <div className="mt-2 grid grid-cols-2 gap-1" role="group" aria-label="Language / 語言">
                            <button
                                type="button"
                                onClick={() => setLanguage('en')}
                                aria-pressed={language === 'en'}
                                className={`rounded-md px-2 py-2 text-sm font-semibold ${
                                    language === 'en'
                                        ? 'bg-blue-600 text-white'
                                        : 'bg-gray-100 text-gray-800 hover:bg-gray-200'
                                }`}
                            >
                                English
                            </button>
                            <button
                                type="button"
                                onClick={() => setLanguage('zh')}
                                aria-pressed={language === 'zh'}
                                className={`rounded-md px-2 py-2 text-sm font-semibold ${
                                    language === 'zh'
                                        ? 'bg-blue-600 text-white'
                                        : 'bg-gray-100 text-gray-800 hover:bg-gray-200'
                                }`}
                            >
                                中文
                            </button>
                        </div>
                    </li>
                </ul>
            </div>
        </nav>
    );
};

export default BurgerMenu;
